window.jeffRenderCartDrawer = async (cartDrawer, parsedState) => {
  const sectionsToRender = cartDrawer?.getSectionsToRender?.() || [];
  const hasDrawerSection = parsedState?.sections?.['cart-drawer'];
  let state = parsedState;

  if (!hasDrawerSection && sectionsToRender.length) {
    const cartUrl = window.routes?.cart_url || `${window.Shopify?.routes?.root || '/'}cart`;
    const refreshUrl = new URL(cartUrl, window.location.origin);
    refreshUrl.searchParams.set('sections', sectionsToRender.map((section) => section.id).join(','));
    refreshUrl.searchParams.set('sections_url', window.location.pathname);
    const refreshResponse = await fetch(refreshUrl.toString(), {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    });
    const refreshedSections = await refreshResponse.json();
    state = { ...parsedState, sections: refreshedSections };
  }

  cartDrawer.classList.remove('is-empty');
  cartDrawer.querySelector('cart-drawer-items')?.classList.remove('is-empty');
  cartDrawer.renderContents(state);
};
